import { Component, Input } from '@angular/core';
import { GlobalEngagementService } from '../../../../http/global-engagement/global-engagement.service';
import { ModalService } from '@usitsdasdesign/dds-ng/modal';
import { ProgressIndicatorService } from '../../../../common/services/progress-indicator.service';
import { CommonService } from '../../../../http/intake/common.service';
import { CommonHelperService } from '../../../../common/services/common-helper.service';
import { IntakeConstant } from '../../../../intake/constants/intake.constant';
import { IntakeSubmissionActionReasonDropdown, SubmissionStatusByActionModel } from '../../../../common/models/submission-action.model';
import { Subject, takeUntil } from 'rxjs';
import { SelectItemOptions } from '@usitsdasdesign/dds-ng/select';
import { OppertunitySubmissionStatusCode } from '../../../../common/models/oppertunity-submission-statusCode.model';
import { selectOptions } from './global-reset-status.helper';
import { GlobalEngagementsConstant } from '../../../constants/global-engagements.constants';

@Component({
  selector: 'app-global-eng-reset-status',
  templateUrl: './global-eng-reset-status.component.html',
  styleUrl: './global-eng-reset-status.component.less'
})
export class GlobalEngResetStatusComponent {
   constructor(
      private readonly modalService: ModalService,
      private readonly globalEngagementService: GlobalEngagementService,
      private readonly progressIndicator: ProgressIndicatorService,
      private readonly commonService: CommonService,
      private readonly commonHelperService: CommonHelperService
    ) {}
  
    @Input() isFooter: boolean = false;
    @Input() size: string = GlobalEngagementsConstant.EMPTY_STRING;
    @Input() isInverse: boolean = false;
    @Input() submissionId: number = 0;
    @Input() submissionStatus: string = GlobalEngagementsConstant.EMPTY_STRING;
    status: string = GlobalEngagementsConstant.EMPTY_STRING;
    submissionStatusAction: SubmissionStatusByActionModel[] = [];
    actionDropdownList: SelectItemOptions[] = [];
    selectedReason: number = 0;
    otherReasonDescription: string = GlobalEngagementsConstant.EMPTY_STRING;
    unsubscriber$: Subject<void> = new Subject<void>();
    textareaOptions = IntakeConstant.TEXT_AREA_SETTINGS_GLOBAL;
    selectOptions = selectOptions;
    statusCodeList!: OppertunitySubmissionStatusCode[];
    showReasonTextBox: boolean = false;
    dropdownOptions: IntakeSubmissionActionReasonDropdown[] = [];
    resetButtonSelected: boolean = false;
  
    ngOnInit(): void {
      this.getActionDropdownData(IntakeConstant.ResetActionID);
      this.commonService
        .getGlobalEngagementStatusCode()
        .pipe(takeUntil(this.unsubscriber$))
        .subscribe({
          next: (response: OppertunitySubmissionStatusCode[]) => {
            this.statusCodeList = response;
          },
          error: (err) => {
            console.error('An error occurred during fetching data: ', err);
          },
        });
    }
    
    getActionDropdownData(id: number): void {
      this.globalEngagementService.getActionReasons(id).subscribe({
        next: (result: IntakeSubmissionActionReasonDropdown[]) => {
          const convertedArray: SelectItemOptions[] = result.map((item: any) => ({
            value: item.reasonId,
            heading: item.reason,
          }));
          this.actionDropdownList = convertedArray;
          this.dropdownOptions = result;
        },
        error: (err: any) => {
          this.progressIndicator.hide();
        },
      });
    }
  
    handleDropDownSelected(data: number): void {
      const selectedObj = this.dropdownOptions.filter(
        (item: IntakeSubmissionActionReasonDropdown) => item.reasonId === data
      );
      selectedObj[0].enableText
        ? (this.showReasonTextBox = true)
        : (this.showReasonTextBox = false);
    }
  
    async saveSubmissionHistory(): Promise<void> {
      const postRequestData = {
        submissionId: this.submissionId,
        currentStatusId: this.statusCodeList[0].id,
        previousStatusId: Number(
          this.statusCodeList.find(
            (x: OppertunitySubmissionStatusCode) =>
              x.statusName === this.submissionStatus
          )?.id
        ),
        submissionActionId: IntakeConstant.ResetActionID,
        reasonId: this.selectedReason,
        otherReasonDescription: this.commonHelperService.trimPrefixEmptySpace(this.otherReasonDescription),
      };
      this.globalEngagementService
        .saveSubmissionHistory(postRequestData)
        .pipe(takeUntil(this.unsubscriber$))
        .subscribe({
          next: (response: any) => {
            console.log(response);
          },
          error: (err) => {
            console.error('An error occurred while saving the data: ', err);
          },
        });
        this.resetButtonSelected = true
      this.close();
    }
  
    formValid(): boolean {
      if (this.selectedReason != 0)
        if (
          this.showReasonTextBox &&
          this.otherReasonDescription != GlobalEngagementsConstant.EMPTY_STRING
        )
          return true;
        else if (!this.showReasonTextBox) return true;
        else return false;
      return false;
    }
  
    close(): void {
      this.modalService.close(this.resetButtonSelected);
    }

}
